import React from "react";
import { Grid, useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";
import FooterBack from "../../../assets/FooterBack.svg";
import LogoFooter from "../../../assets/LogoFooter.svg";
import location2 from "../../../assets/location2.svg";
import Phone from "../../../assets/Phone.svg";
import instagram from "../../../assets/instagram.svg";
import facebook from "../../../assets/facebook.svg";
import twitter from "../../../assets/twitter.svg";
import yt from "../../../assets/youtube.png";
import GoogleIcon from "../../../assets/google.png";
import Email from "../../../assets/Email.svg";
import GooglePlay from "../../../assets/GooglePlay.svg";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const email = "kanhahometutions@gmail.com"; // Replace with the recipient's email
  const subject = "";
  const body = "";
  const currentYear = new Date().getFullYear();


  const handleEmailClick = () => {
    // Create the mailto link
    const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    console.log('hiii',mailtoLink)
    // Redirect to the mailto link
    window.open(mailtoLink, "_blank");
  };
  const isXs = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();

  const handleClickfortutor = () => {
    const playStoreUrl =
      "https://play.google.com/store/apps/details?id=com.kanhahometutions.tutor";
    window.open(playStoreUrl, "_blank");
  };

  const handleClickforstudent = () => {
    const playStoreUrl =
      "https://play.google.com/store/apps/details?id=com.kanhahometutions.student";
    window.open(playStoreUrl, "_blank");
  };

  const khtinstagram = () => {
    const playStoreUrl =
      "https://www.instagram.com/kanha_home_tuition?igsh=c29rOWFyY29wdm5m";
    window.open(playStoreUrl, "_blank");
  };

  const khtfacebook = () => {
    const playStoreUrl =
      "https://www.facebook.com/KanhaHomeTuitions?mibextid=ZbWKwL";
    window.open(playStoreUrl, "_blank");
  };
 
  const khttwitter = () => {
    const playStoreUrl =
      "https://x.com/kanhahometution?s=21";
    window.open(playStoreUrl, "_blank");
  };

  const youtube = () => {
    const playStoreUrl =
      "https://www.youtube.com/@Kanhahome";
    window.open(playStoreUrl, "_blank");
  };

 
  const googleLink = () => {
    const playStoreUrl =
      "https://g.co/kgs/zrvzMcx";
    window.open(playStoreUrl, "_blank");
  };

  return (
    <>
      {/* Footer */}
      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: isXs ? "" : "center",
          backgroundColor: "#20140E",
          paddingBottom: isXs ? "30px" : "15%",
          position:"relative",
          zIndex:3,
          width:"100%"
          // overflow:"none"
        }}
      >
        <img
          src={FooterBack}
          alt="Frame24"
          style={{
            position: "absolute",
            width: "inherit",
            display: isXs ? "" : "none",
            height:"inherit",
            zIndex:1,
            left:0,
            right:0,
            bottom:0,
            padding:0,
         
          }}
        />
        <Grid
          item
          xs={10}
          sm={3}
          md={3}
          lg={3}
          xl={3}
          xxl={3}
          container
          spacing={3}
        >
          <Box style={{ marginTop: isXs ?  "0px":'70px', display: "flex",zIndex:2,  marginBottom: isXs ? '':'10%' }}>
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Box sx={{ textAlign: "center" }}>
                <img
                  src={LogoFooter}
                  alt="LogoFooter"
                  style={{ width: "70%" }}
                />
              </Box>
              <Box
                style={{
                  width: isXs ? "60%" : "95%",
                  color: "white",
                  fontSize: isXs ? "1vw" : "3.8vw",
                  textAlign: isXs ?  "left" : "center",
                  marginLeft: isXs ? "3.5rem" : "0rem",
                  marginTop: isXs ? "" : "2%",
                }}
              >
                Empower your learning journey with Kanha Home Tuitions—where
                potential meets possibility right at your doorstep!
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          xs={10}
          sm={3}
          md={3}
          lg={3}
          xl={3}
          xxl={3}
          container
          spacing={3}
          sx={{ marginBottom: isXs ? '': "10%" }}
        >
          <Box
            style={{
              marginTop: "10%",
              fontSize: "1vw",
              minWidth: "100%",
              display: "flex",
              justifyContent: "center",
              zIndex:2 
            }}
          >
            <Box
              sx={{ width: "80%", display: "flex", justifyContent: "center" }}
            >
              <Box sx={{ width: "60%" , display: 'flex' , flexDirection: 'column' , gap: '0rem' }}>
                <Link to="/" style={{ textDecoration: "none" }}>
                  {" "}
                  <button
                    className="d-flex align-items-center"
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      width: "100%",
                      justifyContent: isXs ? "" : "center",
                    }}
                  >
                    <Box
                      style={{
                        color: "white",
                        marginLeft: "5%",
                        marginTop: "0%",
                        fontSize: isXs ? "" : "3.8vw",
                      }}
                    >
                      Home
                    </Box>
                  </button>
                </Link>
                <Link to="/blogs" style={{ textDecoration: "none" }}>
                  <button
                    className="d-flex align-items-center"
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      width: "100%",
                      justifyContent: isXs ? "" : "center",
                    }}
                  >
                    <Box
                      style={{
                        color: "white",
                        marginLeft: "5%",
                        marginTop: "5%",
                        fontSize: isXs ? "" : "3.8vw",
                      }}
                    >
                      Blogs
                    </Box>
                  </button>
                </Link>
                <Link to="/privacy-policy" style={{ textDecoration: "none" }}>
                  <button
                    className="d-flex align-items-center"
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      width: "100%",
                      justifyContent: isXs ? "" : "center",
                    }}
                  >
                    <Box
                      style={{
                        color: "white",
                        marginLeft: "5%",
                        marginTop: "5%",
                        fontSize: isXs ? "" : "3.8vw",
                      }}
                    >
                      Privacy Policy
                    </Box>
                  </button>
                </Link>
                <Link to="/refund-policy" style={{ textDecoration: "none" }}>
                  {" "}
                  <button
                    className="d-flex align-items-center"
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      width: "100%",
                      justifyContent: isXs ? "" : "center",
                    }}
                  >
                    <Box
                      style={{
                        color: "white",
                        marginLeft: "5%",
                        marginTop: "5%",
                        fontSize: isXs ? "" : "3.8vw",
                      }}
                    >
                      Refund Policy
                    </Box>
                  </button>
                </Link>
                <Link to="/terms-conditions" style={{ textDecoration: "none" }}>
                  {" "}
                  <button
                    className="d-flex align-items-center"
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      width: "100%",
                      justifyContent: isXs ? "" : "center",
                    }}
                  >
                    <Box
                      style={{
                        color: "white",
                        marginLeft: "5%",
                        marginTop: "5%",
                        fontSize: isXs ? "" : "3.8vw",
                      }}
                    >
                      Terms & Conditions
                    </Box>
                  </button>
                </Link>

                <Link
                    to="/sitemap"
                    style={{ textDecoration: "none" }}
                  >
                    {" "}
                    <button
                      className="d-flex align-items-center"
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        width: "100%",
                        justifyContent: isXs ? "" : "center",
                      }}
                    >
                      <Box
                        style={{
                          color: "white",
                          marginLeft: "5%",
                          marginTop: "5%",
                          fontSize: isXs ? "" : "3.8vw",
                        }}
                      >
                        Sitemap
                      </Box>
                    </button>
                  </Link>
                  <Link
                    to="/contact-us"
                    style={{ textDecoration: "none" }}
                  >
                    {" "}
                    <button
                      className="d-flex align-items-center"
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        width: "100%",
                        justifyContent: isXs ? "" : "center",
                      }}
                    >
                      <Box
                        style={{
                          color: "white",
                          marginLeft: "5%",
                          marginTop: "5%",
                          fontSize: isXs ? "" : "3.8vw",
                        }}
                      >
                        Contact Us
                      </Box>
                    </button>
                  </Link>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          xs={10}
          sm={3}
          md={3}
          lg={3}
          xl={3}
          xxl={3}
          container
          spacing={3}
          sx={{ marginBottom: isXs ? '': "10%" }}
        >
          <Box
            style={{
              marginRight: "10%",
              marginTop: "10%",
              fontSize: "1vw",
              display: "flex",
              justifyContent: "center",
              zIndex:2 
            }}
          >
            <Box
  sx={{
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  }}
>
  {/* Address */}
  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
    <img src={location2} alt="location2" width={25} />
    <Box
      sx={{
        color: "white",
        fontSize: isXs ? "14px" : "18px",
      }}
    >
      Plot No. 45, Vaishali Nagar, Jaipur
    </Box>
  </Box>

  {/* Phone */}
  <Box
  sx={{
    display: "flex",
    alignItems: "flex-start",
    gap: 2,
  }}
>
  <img src={Phone} alt="Phone" width={25} />

  <Box
    sx={{
      color: "white",
      fontSize: isXs ? "14px" : "18px",
      display: "flex",
      flexDirection: isXs ? "row" : "column",
      gap: isXs ? "6px" : "10px",
      flexWrap: "wrap",
    }}
  >
    <a
      href="tel:+91-6376400386"
      style={{
        color: "white",
        textDecoration: "none",
      }}
    >
      +91-6376400386
    </a>

    {!isXs && <span></span>}

    <a
      href="tel:+91-9166100755"
      style={{
        color: "white",
        textDecoration: "none",
      }}
    >
      +91-9166100755
    </a>
  </Box>
</Box>

 {/* Email 1 */}
<Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
  <img src={Email} alt="Email" width={25} />

  <a
    href="mailto:info@kanhahometutions.com"
    style={{
      color: "white",
      textDecoration: "none",
      fontSize: isXs ? "14px" : "18px",
    }}
  >
    info@kanhahometutions.com
  </a>
</Box>

{/* Email 2 */}
<Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
  <img src={Email} alt="Email" width={25} />

  <a
    href="mailto:kanhahometutions@gmail.com"
    style={{
      color: "white",
      textDecoration: "none",
      fontSize: isXs ? "14px" : "18px",
    }}
  >
    kanhahometutions@gmail.com
  </a>
</Box>

{/* Email 3 */}
<Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
  <img src={Email} alt="Email" width={25} />

  <a
    href="mailto:kanhahome04@gmail.com"
    style={{
      color: "white",
      textDecoration: "none",
      fontSize: isXs ? "14px" : "18px",
    }}
  >
    kanhahome04@gmail.com
  </a>
</Box>

  {/* Social Icons */}
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: "1rem",
      mt: 2,
    }}
  >
    <img
      style={{ cursor: "pointer" }}
      onClick={khtinstagram}
      src={instagram}
      alt=""
      width={30}
    />

    <img
      style={{ cursor: "pointer" }}
      onClick={khtfacebook}
      src={facebook}
      alt="facebook"
      width={30}
    />

    <img
      style={{ cursor: "pointer" }}
      onClick={khttwitter}
      src={twitter}
      alt=""
      width={30}
    />

    <img
      style={{ cursor: "pointer" }}
      onClick={youtube}
      src={yt}
      alt=""
      width={30}
    />

    <img
      style={{ cursor: "pointer" }}
      onClick={googleLink}
      src={GoogleIcon}
      alt=""
      width={30}
    />
  </Box>
</Box>
          </Box>
        </Grid>
        <Grid
          item
          xs={10}
          sm={3}
          md={3}
          lg={3}
          xl={3}
          xxl={3}
          spacing={3}
          sx={{ marginTop: "0%",zIndex:2  }}
        >
          <Box
            style={{
              marginTop: isXs ? "0px" : "1%",
              minWidth: "100%",
              textAlign: "left",
              display: "flex",
              flexDirection: isXs ? "column" : "row",
              gap: "1rem",
              zIndex:2 
            }}
          >
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                gap: isXs ? "1rem" : ".5rem",
              }}
            >
              <Box style={{ color: "white" }}>For Tutor</Box>

              <img
              
                onClick={handleClickfortutor}
                src={GooglePlay}
                alt="GooglePlay"
                style={{ width: isXs ? "60%" : "90%", cursor: 'pointer' }}
              />
            </Box>

            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                gap: isXs ? "1rem" : ".5rem",
              }}
            >
              <Box style={{ color: "white" }}>For Learner</Box>

              <img
                onClick={handleClickforstudent}
                src={GooglePlay}
                alt="GooglePlay"
                style={{ width: isXs ? "60%" : "90%", cursor: 'pointer'  }}
              />
            </Box>

          </Box>
        </Grid>
      </Grid>

      {/* footer */}
      <Grid
        container
        className="py-3 px-2"
        sx={{
          marginTop: isXs ? "" : "",
          backgroundColor: "#A6653F",
          fontSize: isXs ? "1vw" : "3vw",
          color: "white",
          zIndex:4
        }}
      >
        <Box style={{ textAlign: isXs ? "start" : "center", margin: "0 auto" }}>
          &copy;{currentYear} Kanha Home Tutions. All Right Reserved{" "}
        </Box>
        <Box style={{ textAlign: isXs ? "end" : "center", margin: "0 auto" }}>
          Powered by Infomagine Softwares Pvt. Ltd.
        </Box>
      </Grid>
    </>
  );
};

export default Footer;
